// Casse une chaîne d'imports lourde (campagne perf, suite #680) : ces enums vivaient dans
// le COMPOSANT PharmacySignDocument, importé par un fichier de routes (getFrontOffice
// SoundPharmacien) — donc par CONSTANT_ROUTES, donc par TOUTES les pages via getRoutes.
// Résultat mesuré : ApiMutationEndpoint entier (3 000 lignes) + zod (244 Ko décodés)
// embarqués jusque dans la page de LOGIN. Un enum n'a rien à faire dans un composant.

/** Types de documents signables (flux Universign/Yousign historiques + signable_document). */
export enum typeDocument {
  CONTRAT_SOUND = 'contrat_sound',
  CONTRAT_INSIGHT = 'contrat',
  CONTRAT_SCHOOL = 'contrat_school',
  CONTRAT_STORE = 'contrat_store',
  CONTRAT_STORE_BAG = 'contrat_store_bag',
  CONTRAT_LIFESCAN = 'contrat_lifescan',
  CONTRAT_LIFESCAN_DT = 'contrat_lifescan_martinique',
  ADHESION_STORE = 'adhesion_store',
  CONVENTION_CADRE = 'convention_cadre',
  CONVENTION_SPECIALE = 'convention_speciale',
  CONTRAT_APPLICATION = 'contrat_application',
  CREDIT_ESTIMATE = 'credit_estimate',
  CONTRACT_SACEM_MANDAT = 'contrat_sacem_mandat',
  // Nouveau système de document signable (généré depuis signableDocumentTemplate, via taskId).
  SIGNABLE_DOCUMENT = 'signable_document',
}

/** Distributeurs radio (transmetteur d'une pharmacie Sound). */
export enum RADIO_DISTRIBUTOR {
  PHARMARADIO = 'pharmaradio',
  RADIOSHOP = 'radioshop',
  SAOOTI = 'saooti',
}
